import {event} from '../modules/event';
import {CrossDomainTransport} from '../modules/CrossDomainTransport';
import {scriptonload} from '../modules/scriptonload';
import {page} from '../modules/page';

class ToBuy {
    constructor(btn) {
        if(!APP.vars.isMobile){
            this._createElements(btn);
            this._addEvents();
        }
        else{
            var self = this;

            if(!window.jQuery) scriptonload('/static/js/vendors/jquery-1.12.0.min.js', function(){
                self._runMobile.call(self, btn);
            });
            else this._runMobile(btn);
        }
    }

    _createElements(btn){
        this.btn = btn;
        this.dataParam = false;

        if(!APP.vars.rbKey){
            /*
             * TODO
             * DEPRECATED
             * */
            var el = document.getElementsByTagNameNS('*', 'rb:rich')[0];
            APP.vars.rbKey = el.getAttribute('key');
        }
    }

    _addUtmToUrl(src){
        if(APP && APP.vars && APP.vars.ticketsUtm ){
            const sign = src.indexOf('?') == -1 ? '?' : '&';
            if(src.indexOf('?'))
            src = src + sign + APP.vars.ticketsUtm.utm + '=' + APP.vars.ticketsUtm.value
        }
        return src;
    }

    _addEvents(){
        var self = this;
        this._showPopupLocking = function(event){
            event.preventDefault();
            if(self.dataParam === false) self.dataParam = JSON.parse(this.getAttribute('data-param'));
            //
            if(self.dataParam.type === 'kinohod') {
                /* TODO заплатка от Антошки. У кинохода2 в id присутствует _ избавляемся от него */
                self.dataParam.uid = self.dataParam.uid.replace(/^_/, '');
                self._showKinohod.call(self);
            }
            else self._showRambler.call(self); /* TODO premieralight */

            self._sendStat(self.dataParam, 'open');
        };

        event.add(this.btn, 'click',  this._showPopupLocking);
    }

    _showKinohod(){
        var self = this;
        var param = this.dataParam;
        var apikey = param.apikey || 'ba22a607-2480-3c14-80a1-c92613e30bbf',
            src = this._addUtmToUrl('https://kinohod.ru/widget/seances/'+ param.uid +'?apikey='+ apikey +'&utm_source='+ apikey +'&utm_content='+ param.userid +'&type=seance&__referrer=boxoffice&_referrer=' + location.origin),
            popup = uPopup({
                addClass:'popup-tobuy popup-tobuy-kinohod tobuy tobuy-kinohod',
                name:'tobuy',
                content:
                '<header class="tobuy_header">' +
                   '<div class="tobuy_header_left">' +
                        '<a class="mainLogo mainLogo-tobuy" href="/">' +
                            '<span class="mainLogo_title g-active">' +
                                '<span class="mainLogo_letter">К</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">н</span><span class="mainLogo_letter">о</span><span class="mainLogo_letter">а</span><span class="mainLogo_letter">ф</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">ш</span><span class="mainLogo_letter">а</span>' +
                            '</span>' +
                        '</a>' +
                    '</div>' +
                    '<div class="tobuy_header_right">' +
                        '<span class="tobuy_header_text">' +
                            'Проблемы с билетами?<br />' +
                            'Телефон поддержки' +
                        '</span>' +
                        '<span class="tobuy_header_handset">' +
                            '<svg class="symbol symbol-handset symbol-handset-tobuy" role="img"><use xlink:href="/static/img/symbols/sprite.svg#handset"></use></svg>' +
                        '</span>' +
                        '<span class="tobuy_header_phone">8 (800) 333 80 97</span>' +
                    '</div>' +
                '</header>'+
                '<iframe id="widgetFrame"  name="widgetFrame" data-ToBuy="partner" class="tobuy_partner" src="'+ src +'"></iframe>',
                oncloseBefore: () => {
                    this._onClosePopup();
                    return true;
                }
            }),
            iframe = popup.content.querySelector('[data-ToBuy="partner"]'),
            portal = new CrossDomainTransport(window.location.href, 'widgetFrame', {
                'check.kh.frame': function onWidgetFrame(data){
                    portal.post('embedded.kh.frame'); //Это дает понять виджету что он во фрейме
                    portal.post('boxoffice.kh.ready'); //Это как раз запуск событий из виджета в главное окно
                },
                'resize.kh.widget': function onWidgetResize(data) {
                    //iframe.style.height = data.height + 'px';
                    //console.log(data.height);
                },
                'scroll.kh.widget': function onWidgetScroll() {console.log('scroll.kh.widget')},
                'info.kh.order': function onWidgetSuccess(data) {
                    self._onSuccess.call(self, data, self.dataParam);
                }
            });

        //

        iframe.onload = () => {
            portal.post('loaded', {_isEmbeddedWithBoxoffice: true, type: 'movie|movies|seance|seances|cinema|cinemas'})
        };
    }

    _showRambler(){
        var param = this.dataParam;
        var self = this;
        var src = this._addUtmToUrl('https://w.kassa.rambler.ru/event/'+ param.uid +'/'+ APP.vars.rbKey +'/' + encodeURIComponent(window.location.toString()) + '/'),
            popup = uPopup({
                addClass:'popup-tobuy popup-tobuy-rambler tobuy tobuy-rambler',
                name:'tobuy',
                content:
                '<header class="tobuy_header">' +
                '<div class="tobuy_header_left">' +
                '<a class="mainLogo mainLogo-tobuy" href="/">' +
                '<span class="mainLogo_title g-active">' +
                '<span class="mainLogo_letter">К</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">н</span><span class="mainLogo_letter">о</span><span class="mainLogo_letter">а</span><span class="mainLogo_letter">ф</span><span class="mainLogo_letter">и</span><span class="mainLogo_letter">ш</span><span class="mainLogo_letter">а</span>' +
                '</span>' +
                '</a>' +
                '</div>' +
                '<div class="tobuy_header_right">' +
                '<span class="tobuy_header_text">' +
                'Проблемы с билетами?<br />' +
                'Телефон поддержки' +
                '</span>' +
                '<span class="tobuy_header_handset">' +
                '<svg class="symbol symbol-handset symbol-handset-tobuy" role="img"><use xlink:href="/static/img/symbols/sprite.svg#handset"></use></svg>' +
                '</span>' +
                '<span class="tobuy_header_phone">8 (800) 505-67-91</span>' +
                '</div>' +
                '</header>'+
                '<iframe data-ToBuy="partner" scrolling="no" class = "tobuy_partner" src="'+ src +'"></iframe>',
                oncloseBefore: () => {
                    this._onClosePopup();
                    return true;
                }
            }),
            onMessage = function(event) {
                if (event.origin === 'https://w.kassa.rambler.ru') {
                    //есть косяки, что-то передается в виде объекта, что-то в виде строки
                    if (typeof event.data === 'object' && event.data.id === 'kassa-widget-successful-payment' && event.data.orderId) { //{id: "kassa-widget-successful-payment", orderId: "b2c5ab40-9482-482e-9210-dd0d03ffe5e7"}
                        self._onSuccess.call(self, event.data, self.dataParam);

                        //console.log('Билет куплен, отправляем запрос');
                        var data = 'orderkey=' + event.data.orderId;
                        var xhr = new XMLHttpRequest();
                        xhr.open("POST", 'https://api.kinoafisha.info/sales/rk/', true);
                        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                        xhr.withCredentials = true;
                        xhr.onload = function () {// console.log('orderKey передался')};
                            xhr.send(data);
                        }
                    }
                }
            }
        //
        window.addEventListener('message', onMessage, false);
    }

    _onSuccess(widgetData, dataParam){ /* TODO - когда переедет все в одно место  - будет и так доступно this.dataParam */
        console.log('Успешная покупка билета _onSuccess');
        const messageParam = {status:'success', initialData:dataParam, widgetData:widgetData};
        if(window.top.ReactNativeWebView) window.top.ReactNativeWebView.postMessage(messageParam, "*", ); //для приложения
        else window.top.postMessage(messageParam, "*", );
        this._sendStat(dataParam, 'success');
    }

    _onClosePopup(){
        uPopup.closeAll();

        var count = regAuthObj.isAuth ? 1 : 2;
        var random = APP.helpers.randomInteger(1,count);

        switch(random){
            case 1:
                this._showAllcafePopup();
                break;
            case 2:
                regAuthObj.authForm.showPopup({"cls":"popup-middle-saveTicket"});
                break;
        }
    }

    _showAllcafePopup(){
        if ( APP.vars.showAllcafe ) {
            const path = APP.pagesParam['allcafe']['ajax'].replace('[CINEMAID]', this.dataParam.cinemaid);
            page({"name":"allcafe", ajax:path});
        }
        else return false;
    }

    _sendStat(param, type){
        switch (type){
            case 'open': { //Открытие виджета
                var page = window.location.pathname + 'tickets/';
                try{
                    gtag('config', 'UA-21667993-5', {
                        'page_path': page
                    });
                } catch(e){
                    if(console) console.error('GA при покупке билета не сработал');
                }

                if(param.movieid == '8356092') {
                    try{
                        fbq('track', 'InitiateCheckout');
                    } catch(e){
                        console.log(e);
                    }
                }
                break;
            }

            case 'success': {//успешная покупка билета
                console.log('Отправляем стату успешной покупки билета');
                ['tickets_buy', 'tickets_buy_' + param.type ].forEach((event)=>{
                    try{
                        gtag('event', event, {
                            'event_category': 'engagement',
                            'event_action': 'tickets',
                            'event_label': 'buy'
                        });
                    } catch(e){
                        if(console) console.log('gtag не существует')
                    };

                    try{
                        yaCounter28763351.reachGoal(event);
                    } catch(e){
                        if(console) console.log('ym не существует')
                    };
                });
                break;
            }
        }
    }

    del(){
        event.remove(this.btn, 'click', this._showPopupLocking);
    }

    destroy(){
        this.del();
    }

    /* TODO */
    _runMobile(newBtn){
        var self = this;

        $(function(){
            var $tobuy,
                $closeBtn,
                $body = $(document.body),
                top,
                bodyClass = 'tobuy', /* на отельной странице доавляется tobuy-widget Пример - tobuy-widget.php */
                isWidget = false; /* Покупка билета может подключаться на отдельной странице */

            function buy(e, widget){
                if(widget) { /* если передается нужные параметры гетом - значит это виджет */
                    bodyClass = 'tobuy tobuy-widget';
                    isWidget = true;
                }
                else dataParam = JSON.parse(this.getAttribute('data-param'));

                /* TODO заплатка от Антошки. У кинохода2 в id присутствует _ избавляемся от него */
                if(dataParam.type === 'kinohod') dataParam.uid = dataParam.uid.replace(/^_/, '');

                createElements();
                show();
                addClose();
                self._sendStat(dataParam, 'open');

                if(dataParam.type === 'rambler') {
                    addNewWidgetRamblerIframe();
                }
                else addWidgetKinohodIframe();
            }

            function createElements(){
                const type = dataParam.type;

                if(type === 'rambler'){
                    var phone = '8 800 505-67-91';
                    var patch = '';
                    var cls = 'tobuy-box-rambler'
                } else{
                    var phone = '8 800 333 80 97';
                    var patch = '<div class="tobuy-header-patch">Не влезает форма оплаты? Переверни телефон!</div>';
                    var cls = 'tobuy-box-kinohod'
                }


                $tobuy = $('<div class="tobuy-box ' + cls + '">' +
                    '<div class="tobuy-header">' +
                    '<div class="tobuy-header-content">' +
                    '<div class="tobuy-header-left">' +
                    '<a class="tobuy-header-logo" href="/main.php"></a>' +
                    '</div>'+
                    '<div class="tobuy-header-right">' +
                    '<img class="tobuy-header-handset" src="/static/mobile/img/phone.png" alt=""/>'+
                    '<a class="tobuy-header-phone" href="tel:'+ phone.replace(/ /g, '') +'">'+ phone +'</a>' +
                    '</div>'+
                    '</div>'+ patch +
                    '<div class="tobuy-header-close">×</div>' +
                    '</div>' +
                    '</div>');

                $closeBtn = $('.tobuy-header-close', $tobuy);
            }

            function show(){
                /* TODO
                 * по-хорошему нужно предусмотреть измененние высоты при повороте и масштабе (если есть)
                 */
                top = window.pageYOffset;

                $(document.body).append($tobuy);
                $body.addClass(bodyClass);
            }

            function addClose(){
                $closeBtn.click(function(){
                    $body.removeClass(bodyClass);
                    window.scrollTo(0, top);
                    $closeBtn.unbind('click');
                    $tobuy.remove();
                    $tobuy = null;
                    $closeBtn = null;
                    top = null;

                    if(!isWidget) {
                        /*
                     * Для виджета авторизация не нужна
                     * */
                        var count = isUserAuth ? 1 : 2;
                        var random = APP.helpers.randomInteger(1,count);

                        /* TODO */
                        /*switch(random){
                            case 1:
                                showAllcafePopup();
                                break;
                            case 2:
                                APP.auth.tryAuth(false, {"cls":"authPopup-saveTicket"});
                                break;
                        }*/
                    }
                    else {
                        /* для виджета не показываем */
                    }
                });
            }

            function addWidgetKinohodIframe(){
                var apikey = dataParam.apikey || APP.vars.khKey, /* чтобы были одинаковые  урлы с десктопом */
                    src = self._addUtmToUrl('https://kinohod.ru/widget/seances/'+ dataParam.uid +'?apikey='+ apikey +'&utm_source='+ apikey +'&utm_content='+ dataParam.userid +'&type=seance&__referrer=boxoffice&_referrer=' + location.origin),

                    /* TODO */
                    onMessage = function(event){
                        console.log('onMessage origin', event.origin);
                        console.log('onMessage data', event.data);
                    };

                //Прокидываем метку в урл из разметки, если есть


                // В приложении в айфоне на киноходе не работает форма оплаты сбера.
                // Поэтому просто пока редиректим
                if(dataParam.app == 'ios') document.location = src;
                else $tobuy.append('<iframe id="widgetFrame" name="widgetFrame" class="tobuy-iframe" scrolling="no" src="'+ src +'"></iframe>');

                window.addEventListener('message', onMessage, false);

                var iframe = $tobuy.find('iframe.tobuy-iframe')[0],
                    portal = new CrossDomainTransport(window.location.href, 'widgetFrame', {
                        'check.kh.frame': function onWidgetFrame(data){
                            portal.post('embedded.kh.frame'); //Это дает понять виджету что он во фрейме
                            portal.post('boxoffice.kh.ready'); //Это как раз запуск событий из виджета в главное окно
                        },
                        'resize.kh.widget': function onWidgetResize(data) {
                            console.log('WidgetResize', data);
                        },
                        'scroll.kh.widget': function onWidgetScroll(data) {
                            console.log('scroll.kh.widget', data)
                        },
                        'info.kh.order': function onWidgetSuccess(data) {
                            console.log('info.kh.order', data)
                            self._onSuccess.call(self, data, dataParam);
                        }
                    });
                iframe.onload = () => {
                    portal.post('loaded', {_isEmbeddedWithBoxoffice: true, type: 'movie|movies|seance|seances|cinema|cinemas'});
                };
            }

            function addNewWidgetRamblerIframe(){
                var src = self._addUtmToUrl('https://w.kassa.rambler.ru/event/'+ dataParam.uid +'/'+ APP.vars.rbKey +'/' + encodeURIComponent(window.location.toString()) + '/'),
                    onMessage = function(event){
                        if(event.origin === 'https://w.kassa.rambler.ru') {
                            //есть косяки, что-то передается в виде объекта, что-то в виде строки
                            if(typeof event.data === 'object' && event.data.id === 'kassa-widget-successful-payment' && event.data.orderId){ //{id: "kassa-widget-successful-payment", orderId: "b2c5ab40-9482-482e-9210-dd0d03ffe5e7"}
                                self._onSuccess.call(self, event.data, dataParam);
                                //console.log('Билет куплен, отправляем запрос');
                                $.ajax({
                                    url: 'https://api.kinoafisha.info/sales/rk/',
                                    type: 'POST',
                                    data: {
                                        orderkey: event.data.orderId
                                    },
                                    xhrFields: {
                                        withCredentials: true
                                    }
                                });
                            }
                        }
                    };

                //
                $tobuy.append('<iframe class="tobuy-iframe" src="'+ src +'"></iframe>');
                window.addEventListener('message', onMessage, false);
            }

            function showAllcafePopup() {
                if ( APP.vars.showAllcafe ) {
                    const path = APP.pagesParam['allcafe']['ajax'].replace('[CINEMAID]', dataParam.cinemaid);
                    page({"name":"allcafe", ajax:path});
                }
                else return false;
            }


            //
            const search = location.search.substring(1);
            let dataParam;
            if(search){
                dataParam = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                if(dataParam.type == 'kinohod' || dataParam.type == 'rambler'){
                    buy(false, true);
                    return;
                }
            }

            $(newBtn).click(buy);

        });
    }
}

export {ToBuy}; 




































